import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import posthog from 'posthog-js';

import './index.scss';
import Color from '@tool/color';
import { CloseIcon20, ZhiWeiIcon, ZhiNengIcon, GoCircleIcon } from '@styled/icon';
import moTypicalPosition, {
  initTypicalPosition, onJob, lookAll,
} from './store';
import Empty from '@comp/empty';
import moUser from '@store/user';
import moIndex from '../../store/index';
import { toReport } from './store';

interface IProps {}
interface IState {}

const DButton = styled(Button)(() => ({
  padding: '6px 10px',
  fontSize: '14px',
  fontWeight: 400,
  whiteSpace: 'nowrap',
}));

const EButton = styled(Button)(() => ({
  height: '30px',
  padding: '0 16px',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: 1,
  borderRadius: '4px',
  color: Color.primaryColor(1),
  backgroundColor: Color.whiteColor(1),

  '&:hover': { backgroundColor: Color.whiteColor(0.8) },
}));

const TypicalPosition = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { isLogin } = moUser;
  const { industry } = moIndex;
  const { jobList, jobCount, categoryCount } = moTypicalPosition;

  useEffect(() => {
    return () => {};
  }, []);

  const onReport = (child: any, item: any) => {
    posthog.capture('行业研究-典型职位', {});
    const backUrl = `/market/industry?type=overview&industryCode=${industry.code}&z=`;
    const newVal = { ...child, ...{ active: true } };
    const arr: any[] = [];
    arr.push(newVal);

    toReport(backUrl, arr, industry.code);
  };

  return (
    <section className="typical-position_10">
      <strong className="sub-11">典型职位</strong>
      {!isEmpty(jobList) ? (
        <section className={[
          "position-11", isLogin ? '' : 'mock-100',
        ].join(' ')}>
          <p className="line-11">
            <span className="span-10">职能</span>
            <span className="span-11">职位</span>
          </p>
          <section className="section-11">
            {jobList.map((item: any, index: number) => (
              <section key={index} className="section-13">
                <b>{item.category_name}</b>
                <p>
                  {item.typical_job_list?.map((child: any, idx: number) => (
                    <DButton key={child.job_code} onClick={() => onReport(child, item)}>{child.job_name}
                    </DButton>
                  ))}
                </p>
              </section>
            ))}
          </section>

          <section className="section-111">
            <section className="section-113">
              <p className="line-01">
                <ZhiWeiIcon />
                <span>职位数量</span>
                <i>{Number(jobCount).toLocaleString()}</i>
              </p>
              <p className="line-01 line-03">
                <ZhiNengIcon />
                <span>职能数量</span>
                <i>{Number(categoryCount).toLocaleString()}</i>
              </p>
            </section>
            <EButton onClick={lookAll}
              endIcon={<GoCircleIcon color={Color.primary} />}>查看全部
            </EButton>
          </section>
        </section>
      ) : <Empty padding="50px 0" />}
    </section>
  );
};

export default observer(TypicalPosition);
